export default __webpack_public_path__ + "static/media/group54_OLD.7298c430.svg";